const config = {
    // baseURL: "http://localhost:7000/api/v1/",
    baseURL: "https://license.gurooevos.com/api/v1/"
}

export default config